import auditClient from '@/services/AuditClient'

export default {
  fetchAll ({ size: limit, ...params }) {
    return auditClient.sendRequest(
      'GET',
      'api/v1/logs',
      { ...params, limit }
    )
  }
}
